import { render, staticRenderFns } from "./QueuePopUp.vue?vue&type=template&id=c6a9c6a2&"
import script from "./QueuePopUp.vue?vue&type=script&lang=js&"
export * from "./QueuePopUp.vue?vue&type=script&lang=js&"
import style0 from "./QueuePopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports